module.exports = require("react-pdf/dist/Page/AnnotationLayer.css");